export const TAB_ID = {
  FLIGHTS: 'airli',
  HOTELS: 'skhot',
  CARHIRE: 'carhi',
  PACKAGES: 'packa',
} as const;

export const ANALYTICS = {
  FLIGHTS: 'flights',
  HOTELS: 'hotels',
  CARHIRE: 'carhire',
  PACKAGES: 'packages',
};

// NOTE: keep in sync with the duplicate DEFAULT constant in src/server/constants
export const DEFAULT = {
  // TODO: DO WE WANT TO KEEP THESE? THEY ARE REQUIRED PROPS
  URLS: {
    flights: '/flights',
    hotels: '/hotels',
    carHire: '/carhire',
    insurance: '/insurance',
    packages: '/destinations/package-holidays',
  },
};

export const TRACKING = {
  SCHEMA: 'website_header',
  MESSAGES: {
    CLICK: 'Click',
  },
};

export const LOGIN_EVENTS = {
  LOGIN_BUTTON_CLICKED: 'Header Login Button Clicked',
};

export const clickEventItems = {
  airli: 'Flights',
  skhot: 'Hotels',
  carhi: 'Car Hire',
  packa: 'Packages',
  identity: 'Logo',
  cultureInfo: 'Culture Selector',
  authenticationlink: 'Login',
  ssHeaderLinksFaq: 'Help',
  textSearchInput: 'Search Box',
  textSearchInputSubmit: 'Search Box Submit',
  savedList: 'Saved List',
};
